import { Box } from '@mui/material';

import ScheduleCall from './ScheduleCall';
import LoadingSkeleton from './ScheduleCall/LoadingSkeleton';

import { useMember } from 'modules/common/queries/member';
import useCalendlyLinksByRole from 'services/calendly/queries/useCalendlyLinksByRole';
import { SpecialistCalendlyLink } from 'services/calendly/queries/useCalendlyLinks/useCalendlyLinks.interface';
import { MembershipTier } from 'modules/common/types';
import useIsInOAPhase from 'modules/Dashboard/Overview/OnboardingCallBanner/hooks/useIsInOAPhase';
import { isInOnboardingStages } from 'modules/common/utils/memberStage';

const getSpecialistRole = (isOnboardingCompleted: boolean) => {
    return isOnboardingCompleted ? 'Member Relationship Manager' : 'Enrollment Manager';
};

const getSpecialistCalendar = (isOnboardingCompleted: boolean, specialist: SpecialistCalendlyLink | undefined) => {
    return isOnboardingCompleted ? specialist?.calendars.mrm : specialist?.calendars.em;
};

export default function MessageCenterFooter() {
    const { data: member } = useMember();

    const isEssentialMember = member?.membership_tier === MembershipTier.essential;

    const role = getSpecialistRole(!isInOnboardingStages(member?.stage));
    const { data: specialistLink, isLoading } = useCalendlyLinksByRole(role);

    const { isInOAPhase, isPendingLaunchpadTasks } = useIsInOAPhase();

    const selectedCalendar = getSpecialistCalendar(!isInOnboardingStages(member?.stage), specialistLink);

    // Wait for member to resolve before rendering
    if (!member?.membership_tier) {
        return null;
    }

    // Hide the schedule call button entirely for Essential members
    if (isEssentialMember) {
        return null;
    }

    // Hide if member is in OA phase (only payroll/accounting/EBB tasks remain)
    if (!member || !selectedCalendar?.schedule_url || isPendingLaunchpadTasks || isInOAPhase) {
        return null;
    }

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                px: 3,
            }}>
            {isLoading ? (
                <LoadingSkeleton />
            ) : (
                <ScheduleCall
                    member={member}
                    selectedCalendar={selectedCalendar}
                    specialistName={specialistLink?.specialist_name}
                />
            )}
        </Box>
    );
}
